import React, { useEffect, useState } from 'react'
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import IssuerNavigator from '../../components/DashBoard/IssuerNavigator'
import templateStyles from "../DashBoard/Templates/Templates.module.css";
import style from "./CompanyProfile.module.css";
import { AuthConsole, convertDateFormat, setDate } from '../../Utils/helper';
import API from "../../ApiConfig";
import { BASE_URL, EXPORT_PAYMENT_ORDERS, GENERATE_CREDIT_NOTE, GET_ALL_COMPANIES, GET_CREDIT_DEBIT_REASONS, GLOBAL_PAYMENTS, REFUND_TRANSACTION, USER_TOKEN } from '../../Utils/constant';
import ShimmerLoader from '../../components/ShimmerLoader';
import Pagination from './ExternalDash/Pagination';
import cogoToast from 'cogo-toast-react-17-fix';
import styles from "./AllUsers.module.css"
import ReactPortalModal from '../../components/ReactPortalModal';
import useRefreshToken from '../../Hooks/usegenerateToken';
import CustomDropDown from '../../components/CustomDropDown';
import Dropdown from './Dropdown';
import SearchDropdown from './ExternalDash/Employment/searchDropdown';
import filterStyles from "./FilterBar.module.css";
import PageSizeSelector from '../../Utils/PageSizeSelector';
const Payments = () => {
useRefreshToken(BASE_URL + USER_TOKEN)
    const[loading, setLoading]=useState(false)
    const[payments, setPayments]=useState([])
    const[currentPage, setCurrentPage]=useState(1)    
    const[totalPages, setTotalPages]=useState(1)

    const[search, serSearch]=useState(null);
    const [isOpen, setisOpen]=useState(false)

    
    const [invoicePreview, setPreview]=useState(null)
    const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
    const[selectedValue, setSelectedValue]=useState("")
    const[selectedStatus, setSelectedSatus]=useState("All")
    const[companiesList, setCompaniesList]=useState([])
    const [searchText, setSearchText]=useState("")
    const [company, setCompany]=useState({
      "id": 0,
            "name": "Select Issuer",
            "issuers": [],
            "verifiers": []
    })
    const [verifiername, setVerifierName]=useState({
      "id": 0,
      "name": "Select Verifier",
      "issuers": [],
      "verifiers": []
    })
    const [verifierList, setVerifierList]=useState([])
    
    const [sortBy,setSortBy]=useState({
      key:"created_at",
      direction:"desc"
    })


    const [reasons, setReasons]=useState("")
    const [selectedReason, setSelectedReason]=useState("")

    const categories = {
      deviationReasons: reasons["Deviation in Client Contract/Agreement terms"],
      waiverReasons: reasons["Waiver"],
      operationalIssues: reasons["Operational issues"],
      nonRevenueAffecting: reasons["Non-Revenue Affecting CN's"]
    }

    const [transactionId, setTransactionId]=useState("")
    const[pageSize, setPageSize]=useState(10)
    const getPayments=(status)=>{

      setLoading(true)

    const  params={
        page: currentPage,
        issuer_company_id: company.id,
        verifier_company_id: verifiername.id,
        sort_by: sortBy.key,
        sort_order: sortBy.direction,
        search: searchText,
        status: selectedStatus || status || "", // fallback
        page_size:pageSize
      }
      if (dateRange.startDate && dateRange.endDate) {
        params.start_date = dateRange.startDate;
        params.end_date = dateRange.endDate;
      }
      API.get(GLOBAL_PAYMENTS,{params})
      .then(res=>{
        if(res.data.status===200){
          setLoading(false)
          setPayments(res.data.data.items)
          setTotalPages(res.data.data.total_pages)
        }
      })

      .catch(err=>{
        setLoading(false)
        AuthConsole(err);
        
      })
    }
    useEffect(()=>{
      getAllCompanies_issuer()
      getAllCompanies_verifier()
    },[])

    const getAllCompanies_issuer = () => {
      setLoading(true);
      API.get(GET_ALL_COMPANIES + `?company_type=Issuer`)
        .then((res) => {
          if (res.data.status == 200) {
            setLoading(false);
            setCompaniesList(res?.data?.data);
          }
        })
  
        .catch((err) => {
          setLoading(false);
          AuthConsole(err);
        });
    }

    const getAllCompanies_verifier = () => {
      setLoading(true);
      API.get(GET_ALL_COMPANIES + `?company_type=verifier`)
        .then((res) => {
          if (res.data.status == 200) {
            setLoading(false);
            setVerifierList(res?.data?.data);
          }
        })
  
        .catch((err) => {
          setLoading(false);
          AuthConsole(err);
        });
    }
    const handleSelect = (selectedItem, type) => {
      if (type === "Verifier") {
        setVerifierName(selectedItem);
      } else if (type === "Issuer") {
        setCompany(selectedItem);
  
      }
    }
    const SortList=(sortItem)=>{
      let direction = "asc";

       if (sortBy.key === sortItem && sortBy.direction === "asc") {
          direction = "desc";
        }

  const newSortBy = { key:sortItem, direction }
      setSortBy(newSortBy)
    }
    const handlePageChange=(newPage)=>{
      setCurrentPage(newPage)    
    }
    const handlePayment=(e,item)=>{

      e.preventDefault();
      setLoading(true)

      const apiData={
        transaction_id:item.transaction_id,
        reason:null
      }

      API.post(REFUND_TRANSACTION, apiData)
      .then(res=>{
        if(res.status==200){
          setLoading(false)
          cogoToast.success(res.data.status)
          getPayments()
        }
        
      })
      .catch(err=>{
        setLoading(false)
        AuthConsole(err);
        
      })
      
    }

     const handleShowCreditNote=(e, item)=>{
          e.preventDefault();
          const creditNoteUrl = item?.credit_note_pdf_url;
        
          if (!creditNoteUrl) {
            cogoToast.error("Credit note URL is missing");
            return;
          }
        
          // Just open in new tab or trigger download directly
          const link = document.createElement("a");
          link.href = creditNoteUrl;
          link.setAttribute("download", `credit_note_${item.payer_name || "file"}.pdf`);
          link.setAttribute("target", "_blank"); // Optional: open in new tab
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      
    const handleSearch=(e)=>{
      setSearchText(e)
      setCurrentPage(1)
    }
    useEffect(()=>{
      const delayDebounce=setTimeout(()=>{
        getPayments()

      },500)
      return ()=>clearTimeout(delayDebounce)
    },[searchText,selectedStatus,currentPage, company, verifiername, sortBy, dateRange, pageSize])

    
    
    const handleCreditNote=async(e,item)=>{
      setLoading(true)
      e.preventDefault()
      API.get(GET_CREDIT_DEBIT_REASONS)
      .then(res=>{
        if(res.status==200){
          const result = Object.entries(res.data.data).flatMap(([key, arr]) =>
            arr.map(item => ({
              id: item.id,
              key: key, // which category it belongs to
              name: item.reason, // display text
              value: item.reason
            }))
          );
          setReasons(result)
        setLoading(false)
        setReasons(result)
        setisOpen(true)
        setTransactionId(item.transaction_id)
        }               
      })
      .catch(err=>{
        setLoading(false)
        cogoToast.error(err)
      })
    }
    
    const CreditDebitReason=()=>{
      const handleReason=(item, type)=>{
        setisOpen(false)
        setSelectedReason(item)

        setLoading(true)
        let apiData={
          transaction_id:transactionId,
          credit_debit_reason_id:item.id
        }
        API.post(GENERATE_CREDIT_NOTE,apiData)
        .then(res=>{
          if(res.status=200){
            setLoading(false)
            setSelectedReason("")
            getPayments()
          }
          
        })

        
        .catch(err=>{
          setLoading(false)
          setSelectedReason("")
          cogoToast.error(err.response.data.message)
          
        })
      }

      return(
        <>

        <div style={{padding:"15px", height:"350px", display:"flex"}}>
          <div style={{width:"100%"}}>
          <div>
            <div>Reasons</div>
          <Dropdown
          listType={0}
          list={reasons}
          selectedOption={selectedReason}
          label={"Select Reason"}
          onSelect={handleReason}
          Width='25rem'
          />
          </div>
          </div>
          {/* <div>
          <div>Waiver Reason</div>
          <Dropdown
          listType={0}
          list={categories.waiverReasons}
          selectedOption={selectedReason.WaiverReason}
          label={"Select Reason"}
          type={"Waiver Reason"}
          onSelect={handleReason}
          />
          </div>

          <div>
          <div>Operational Issues</div>
          <Dropdown
          listType={0}
          list={categories.operationalIssues}
          selectedOption={selectedReason.operationalIssues}
          label={"Select Reason"}
          type={"Operational Issues"}
          onSelect={handleReason}
          />
          </div>
          <div>
          <div>Non Revenue Affecting</div>
          <Dropdown
          listType={0}
          list={categories.nonRevenueAffecting}
          selectedOption={selectedReason.nonRevenueAffecting}
          label={"Select Reason"}
          type={"Non Revenue Affecting"}
          onSelect={handleReason}
          />
          </div> */}
        </div>
        </>
      )
    }

    
    const handleDateChange = (field, e) => {
      setDateRange((prev) => ({ ...prev, [field]: e }));
    }






    const DocPreview = () => {
      var loading = {
        padding: "1rem",
        height: "10vh",
        width: "-webkit-fill-available",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
      if (!invoicePreview) {
        return (<div style={loading}>
          {"Error in generating PDF"}
        </div>)
      }
      else {
        return (
          <embed
            id="pdf-viewer"
            src={invoicePreview + "#toolbar=0"}
            type="application/pdf"
            style={{width:"52rem"}}
          />
        )
      }
    }

    const handlePageSize=(newSize)=>{
      setPageSize(newSize)
      setCurrentPage(1)
    }
    const handleDownload=(e)=>{
       e.preventDefault();
      
          setLoading(true);
          if (dateRange.startDate !== "" && dateRange.endDate !== "") {
            const apiData = {
              issuer_company_id: company?.id,
              verifier_company_id: verifiername?.id,
      
              status: selectedValue,
              start_date: convertDateFormat(dateRange.startDate),
              end_date: convertDateFormat(dateRange.endDate),
            }
    API.get(EXPORT_PAYMENT_ORDERS, { params: apiData, responseType: "blob" })
        .then((res) => {
          if (res.status == 200) {
            setDateRange({ startDate: "", endDate: "" });
            setCompany({});
            setVerifierName({})
            getPayments()
            const blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `payment_orders_${dateRange.startDate}_to_${dateRange.endDate}.xlsx`;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url)
  }
            }
            )
            .catch((err) => {
                      cogoToast.error(
                        err?.response?.data?.message || "Something went wrong"
                      );
                    })
                    .finally(() => {
                      setLoading(false);
                    });
                } else {
                  setLoading(false);
                  cogoToast.error("Enter Valid Start and End Date");
                }


                }
  
  return (
    <SlideUpWrapper direction="slide-left">
            <div className={[style.companyProfile, templateStyles.templateHeader].join(" ")}>
            <IssuerNavigator
                    title="Payments"
                    actions={() =><></>
                    } step={'/'} />
            </div>
            <div style={{margin:"1rem"}}>
              <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          margin: "10px 0px",
                        }}
                      >
                        <button
              className="btn btn-primary"
              onClick={(e) => handleDownload(e)}
            >
              Export
            </button>
                      </div>
                <div className={filterStyles.filterBar}>
                  <div className={`inputField2 ${filterStyles.searchField}`}>
                    <div className="input1">
                      <div className="content1">
                        <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                        <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                      </div>
                    </div>
                  </div>
                  <div className={filterStyles.selectFilter}>
                    <SearchDropdown apidata={companiesList} displayKey="name" placeholder='Select Issuer...' onSelect={(e)=>{setCompany(e);setCurrentPage(1)}} width='100%'/>
                  </div>
                  <div className={filterStyles.selectFilter}>
                    <SearchDropdown apidata={verifierList} displayKey="name" placeholder='Select Verifier...' onSelect={(e)=>{setVerifierName(e);setCurrentPage(1)}} width='100%'/>
                  </div>
                  <input
                    type="date"
                    className={style.datePicker}
                    value={dateRange.startDate}
                    onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
                  />
                  <input
                    type="date"
                    className={style.datePicker}
                    value={dateRange.endDate}
                    onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
                  />
                  <div className={filterStyles.statusFilter}>
                    <CustomDropDown list={["All","Completed","Pending","Failed"]} selectedOption={selectedStatus} onSelect={(e)=>{setSelectedSatus(e);setCurrentPage(1)}} width="100%"/>
                  </div>
                </div>
            </div>
             <div className="credentials-table" style={{height:"100vh"}}>
                         <table style={{ borderRadius: "10px" }}>
                           <tr className="credentials-header bg-lgray">
             
                             <th className="credentials-th" onClick={(e)=>SortList("search_id")} style={{cursor:"pointer"}}>
                             <div className="credentials-table-text" style={{display:"flex", gap:"4px", alignItems:"center"}}>
                               <div className="credentials-table-text">Search ID</div>
                               <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="search_id"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                                </div>
                             </th>
                             <th className="credentials-th" onClick={(e)=>SortList("employee_id")} style={{cursor:"pointer"}}>
                             <div className="credentials-table-text" style={{display:"flex", gap:"4px", alignItems:"center"}}>
                               <div className="credentials-table-text">Emp ID</div>
                               <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="employee_id"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                              </div>

                             </th>
                             <th className="credentials-th" onClick={(e)=>SortList("transaction_id")} style={{cursor:"pointer"}}>
                             <div className="credentials-table-text" style={{display:"flex", gap:"4px", alignItems:"center"}}>
                               <div className="credentials-table-text">Trans ID</div>
                               <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="transaction_id"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                              </div>
                             </th>
                             <th className="credentials-th" onClick={()=>SortList("invoice_no")} style={{cursor:"pointer"}}>
                              <div className='credentials-table-text' style={{display:"flex", gap:"4px", alignItems:"center"}}>
                               <div className="credentials-table-text">Invoice No</div>
                               <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="invoice_no"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                               </div>
                             </th>
                             <th className="credentials-th" onClick={()=>SortList("total_amount")} style={{cursor:"pointer"}}>
                             <div className='credentials-table-text' style={{display:"flex", gap:"4px", alignItems:"center"}}>
                               <div className="credentials-table-text">Amount</div>
                               <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="total_amount"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                              </div>
                             </th>
             
                             <th className="credentials-th" onClick={()=>SortList("verifier_company_name")} style={{cursor:"pointer"}}>
                             <div className='credentials-table-text' style={{display:"flex", gap:"4px", alignItems:"center"}}>
                               <div className="credentials-table-text">Verifier</div>
                               <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="verifier_company_name"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                              </div>
                             </th>
                             <th className="credentials-th" onClick={()=>SortList("status")} style={{cursor:"pointer"}}>
                             {/* <div className='credentials-table-text' style={{display:"flex", gap:"4px", alignItems:"center"}}> */}
                               <div className="credentials-table-text">Payment Status</div> 
                               <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="status"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                              {/* </div> */}
                             </th>
                             <th className='credentials-th' onClick={()=>SortList("issuer_company_name")} style={{cursor:"pointer"}}>
                                <div className='credentials-table-text'>Issuer</div>
                                <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="issuer_company_name"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                </div>
                             </th>
                             <th className="credentials-th" onClick={(e)=>SortList("created_at")} style={{cursor:"pointer"}}>
                               <div className="credentials-table-text" style={{display:"flex", gap:"4px", alignItems:"center"}}>
                                <div>Created On</div>
                                    <div className={styles.dropdown} style={{cursor:"pointer"}}>
                                    {sortBy.key=="created_at"&&(sortBy.direction === "asc" ? "↑" : "↓")}
                                    </div>
                                </div>
                             </th>
                             <th className='credentials-th'>
                                <div className='credentials-table-text'>Debit</div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text">Credit Note</div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text">Action</div>
                             </th>
             
                           </tr>
                           {loading ? <>
                             <tr className="credentials-tr" >
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                             </tr>
                             <tr className="credentials-tr" >
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                               <td className="credentials-td">
                                 <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                               </td>
                             </tr>
                           </> : payments.length === 0 ?
                             <tr className="credentials-tr">
                               <td colSpan="6" className="credentials-td text-center">
                                 <div className="Data_List">No Payments</div>
                               </td>
                             </tr>
                             :
                             <>
                               {payments.map((i, index) => {
                                 return (
                                   <tr className="credentials-tr" style={{ animationDelay: `${index * 0.1}s` }}>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1" style={{textAlign:"center"}}>{i.search_id}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1" style={{textAlign:"center"}}>{i.employee_id}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1" style={{textAlign:"center"}}>{i.transaction_id}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1" style={{textAlign:"center", paddingLeft:"0px"}}>{i.invoice_no}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1" style={{textAlign:"center"}}>{i.total_amount}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1" style={{textAlign:"center"}}>{i.verifier_company_name}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className={`credentials-table-text1 ${i.payment_status=="COMPLETED"?"Complete":"Pending"}`} style={{width:"auto", textAlign:"center"}}>{i.payment_status}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className={"credentials-table-text1"} style={{textAlign:"center"}}>{i.issuer_company_name}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1" style={{textAlign:"center"}}>{setDate(i.created_at)}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className={`credentials-table-text1`} style={{textAlign:"center"}}>{i.transaction_mode=="DEBIT" && i.total_amount}</div>
                                     </td>
                                     <td className="credentials-td">
                                     <div className={`credentials-table-text1`} style={{textAlign:"center"}}>

                                       <button className="btn btn-primary" onClick={(e)=>i.credit_note_pdf_url!==null && i.invoice_pdf_url!==null?handleShowCreditNote(e,i):handleCreditNote(e,i)}>{i.credit_note_pdf_url==null?"credit":"View CN"}</button>
                                       </div>
                                     </td>
                                     <td className="credentials-td">
                                       {i.invoice_pdf_url ?<div className="credentials-table-text1" style={{cursor:"pointer"}} onClick={()=>setPreview(i.invoice_pdf_url)}><img alt="" src="/eyeoutline.svg" /></div>:i.payment_status=="Completed" && i.invoice_pdf_url==null?<div className="Pending" style={{width:"auto", height:"auto"}}>Invoice Pending</div>:i.payment_status=="Pending"?<div className="Pending">Transaction Pending</div>:""}
                                        
                                     </td>
                                   </tr>)
                               })}
                             </>}
                         </table>

                         <div style={{ margin: "10px" }}>
                           <PageSizeSelector value={pageSize} onChange={handlePageSize}/>
                            <Pagination
                                nPages={totalPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                onPageChange={handlePageChange}
                                loading={loading}
                            />
                        </div>
                        <ReactPortalModal title={"Reasons"} isOpen={isOpen} onClose={()=>setisOpen(false)} blockOutsideClick={true}>
                          <CreditDebitReason/>
                        </ReactPortalModal>
                        
                        <ReactPortalModal title={"Invoice PDF"} isOpen={invoicePreview} onClose={()=>setPreview(null)}>
                        
                                        <DocPreview/>
                        </ReactPortalModal>
                       </div >

    </SlideUpWrapper>
  )
}

export default Payments